import getApi from '../../api/apisauceConfig'
import { AnswerInstance } from '../../model/Questionnaire'
import { serializeAnswerInstance } from './mapper/answerInstance.mapper'
import { AnswerInstanceMutationPayload } from './mapper/answerInstance.model'

export const updateAnswerInstance = (id: number, payload: AnswerInstanceMutationPayload) =>
  getApi().put<AnswerInstance>(`/answer_instances/${id}`, serializeAnswerInstance(payload))
